export default __webpack_public_path__ + "static/media/get-started-rocket.df9a0367.svg";